// extracted by mini-css-extract-plugin
export var fadeIn = "_l5-1";
export var modalContent = "_l5-3";
export var overlay = "_l5-0";
export var popoverContent = "_l5-2";
export var results = "_l5-5";
export var searchInputWrapper = "_l5-4";